<template>
  <div id="settingsEmail">

    <div class="name">Change Email</div>
    
    <div class="settings-content">
      
      <v-text-field
        v-model="$store.getters.profile.email"
        disabled
      ></v-text-field>

      <v-text-field
        ref="inputEmail1"
        type="email"
        label="New Email"
        v-model="email1"
        :rules="rules.email1"
        :validate-on-blur="$refs.inputEmail1 && $refs.inputEmail1.valid"
      ></v-text-field>

      <v-text-field
        ref="inputEmail2"
        type="email"
        label="Confirm New Email"
        v-model="email2"
        :rules="rules.email2"
        :validate-on-blur="$refs.inputEmail2 && $refs.inputEmail2.valid"
      ></v-text-field>
      
    </div>
    
    <div class="buttons">
      <v-btn class="button" :loading="lockout" color="primary" flat @click="save()">SAVE</v-btn>
    </div>
    <div class="clear"></div>

  </div>

</template>

<script>

  export default {
    data () {
      return {
        email1: '',
        email2: '',
        emailTaken: false,
        lockout: false,
        rules: {
          email1: [
            function (e) {
              return !window.regex.email.test(e) ? 'Please enter a valid email.' : true;
            },
            function (e) {
              if (this.emailTaken) {
                this.emailTaken = false;

                return 'Email is taken.';

              } else {
                return true;
              }
            }.bind(this)
          ],
          email2: [
            function (e) {
              return this.email1 !== this.email2 ? 'Emails must match.' : true;
            }.bind(this)
          ]
        }
      }
    },

    methods: {
      save () {
        this.lockout = true;
        var valid = this.validate();

        if (!valid) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.lockout = false;
          return;
        }

        this.$store.dispatch('changeEmail', {
          email: this.email1
        })
        .then(data => {

          this.email1 = '';
          this.email2 = '';

          Toast.show('A verification email has been sent to your new email address.', 'success', { duration: 5000 });
          this.lockout = false;
        })
        .catch(e => {
          
          console.log(e);
          if (e.error && e.error.code && e.error.code === 40031) {
            this.emailTaken = true;
            this.$refs.inputEmail1.validate(true);
          }

          Toast.showError(e);
          this.lockout = false;
        });
      },

      validate () {
        this.$refs.inputEmail1.validate(true);
        this.$refs.inputEmail2.validate(true);

        return (this.$refs.inputEmail1.valid &&
                this.$refs.inputEmail2.valid);
      }
    },

    created () {
      this.$nextTick( () => {
        this.$refs.inputEmail1.valid = true;
      });
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #settingsProfile {
    position: relative;  
  }

</style>



// WEBPACK FOOTER //
// src/components/SettingsEmail.vue